import React from "react";
import { TextControl } from "@tiny/components";

interface TextValueProps {
  type: "string" | "string[]";
  prefixName: string;
  disabled?: boolean;
}

function TextValue(props: TextValueProps) {
  const { type, prefixName, disabled } = props;

  const name =
    type === "string[]"
      ? `${prefixName}.value.value[0]`
      : `${prefixName}.value.value`;

  return (
    <TextControl
      name={name}
      aria-label="Condition value"
      showHelperTextMargin
      required
      disabled={disabled}
      watchValue
    />
  );
}

export default TextValue;
